import { getCurrentInstance } from 'vue';

export function useVuetify() {
  const currentInstance = getCurrentInstance();

  return currentInstance?.proxy.$vuetify;
}
